import { FC, SVGProps } from 'react';
import { LanguageCode } from './language';

export type HsCodeAdditionalFields = 'imei';

// Used in Shipment.items array
// (this type is used during rendering of items during display and editing)
export interface ParcelItem {
  category_id: string;
  hs_code: string;
  description_standart: string;
  description_standart_en: string;
  description_free?: string;
  id: number;
  number_of_items: number;
  value: number;
  is_new?: boolean;
  is_ai_generated?: boolean;
  additional_fields?: Record<string, string[]>;
}

// Used in search response
export class HsCodeResponse {
  hsCode: string = '';
  category_id: string = '';
  description: string = '';
  descriptionEn: string = '';
  descriptionLocalized?: Record<LanguageCode, string>;
  description_free?: string;
  icon?: FC<SVGProps<SVGSVGElement>>;
  additional_fields?: string[];

  constructor(parcelItem: ParcelItem) {
    this.hsCode = parcelItem.hs_code;
    this.category_id = parcelItem.category_id;
    this.description = parcelItem.description_standart;
    this.descriptionEn = parcelItem.description_standart_en;
    if (parcelItem.additional_fields) {
      this.additional_fields = Object.keys(parcelItem.additional_fields).filter(
        (fieldName) => parcelItem.additional_fields![fieldName].length > 0
      );
    }
  }
}

// Used in put/post requests
export class HsCodeRequest {
  id: number;
  category_id: string;
  hs_code: string;
  description: string;
  description_en: string;
  description_free?: string;
  value: number;
  number_of_items: number;
  imei?: string[];
  is_ai_generated?: boolean;
  is_new?: boolean;

  constructor(parcelItem: ParcelItem) {
    this.id = parcelItem.id;
    this.category_id = parcelItem.category_id;
    this.hs_code = parcelItem.hs_code;
    this.description = parcelItem.description_standart;
    this.description_en = parcelItem.description_standart_en;
    this.description_free = parcelItem.description_free;
    this.value = parcelItem.value;
    this.number_of_items = parcelItem.number_of_items;
    this.imei = parcelItem.additional_fields?.imei;
    this.is_ai_generated = parcelItem.is_ai_generated;
    this.is_new = parcelItem.is_new;
  }
}
